<!-- 普通的列表-->
<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" plain :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="name" label="名称"> </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.remark?scope.row.remark:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" class="margin-left20 color-blue" v-preventReClick @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" class="margin-left20 color-blue" v-preventReClick @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title + this.route.menuName" :visible.sync="open" :center="true" width="500px" :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="24">
              <el-form-item label="名称" prop="name">
                <el-input :disabled="!editMode" v-model="form.name" placeholder="请填写名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <my-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="submit">确 定</my-button>
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetDictionarys, RemoveDictionarys, SaveDictionary } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";

export default {
  components: {
    // IconSelect
  },
  mixins: [GetDataMixin],
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        type: this.type,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      // 列表多选
      multiple: true,
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
    };
  },
  props: {
    id: {
      type: Number,
      default () {
        return 0;
      },
    },
    //表类型
    type: {
      type: Number,
      default () {
        return 0;
      },
    },
  },
  methods: {
    handleSelectionChange (selection) {
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      GetDictionarys(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    handleInfo (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.editMode = false;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "编辑";
      this.editMode = true;
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveDictionary(this.form).then((res) => {
          this.open = false;
          this.$my_message(`执行成功`, "success");
          this.getData();
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        name: "",
        type: this.type,
        state: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 取消编辑部门
    cancel () {
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("确认要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveDictionarys({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
